var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.748 1.97754H6.42706C4.1293 1.97754 2.2666 3.84024 2.2666 6.138V14.4589C2.2666 16.7567 4.1293 18.6194 6.42706 18.6194H14.748C17.0457 18.6194 18.9084 16.7567 18.9084 14.4589V6.138C18.9084 3.84024 17.0457 1.97754 14.748 1.97754Z",
    stroke: "#3B7DDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9161 9.77448C14.0188 10.467 13.9006 11.1742 13.5781 11.7956C13.2557 12.417 12.7455 12.921 12.1202 13.2357C11.4948 13.5505 10.7862 13.66 10.095 13.5488C9.40382 13.4376 8.7653 13.1112 8.27027 12.6162C7.77524 12.1212 7.44891 11.4827 7.33769 10.7915C7.22646 10.1003 7.33602 9.39163 7.65077 8.7663C7.96552 8.14096 8.46943 7.6308 9.09083 7.30836C9.71224 6.98593 10.4195 6.86764 11.112 6.97033C11.8184 7.07508 12.4723 7.40424 12.9773 7.90919C13.4822 8.41413 13.8114 9.0681 13.9161 9.77448Z",
    stroke: "#3B7DDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 5.72217H15.1736",
    stroke: "#3B7DDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9702,
    height: 19.9702,
    fill: "white",
    transform: "translate(0.602539 0.313477)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.84f3a7ac4b56057f99de5004b141c460.svg";
export { ForwardRef as ReactComponent };